import styles from './ToniAIChatBotMessage.module.scss';

import { ContentCopy } from '@mui/icons-material';
import { Box, IconButton, Stack } from '@mui/material';
import clsx from 'clsx';
import { marked } from 'marked';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import { Divider } from '../../../dataDisplay/divider/Divider';
import { ToniAIMessageItem } from '../../types';

export interface ToniAIChatMessageProps {
  item: ToniAIMessageItem;
  key: number | string;
}

export const ToniAIChatMessage = (props: ToniAIChatMessageProps) => {
  const { item, key } = props;

  const { t } = useTranslation();

  const snackbar = useSnackbar();

  const copyMarkdown = async (markdown: string) => {
    const html = await marked.parse(markdown, { breaks: true });

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([markdown], { type: 'text/plain' }),
        }),
      ]);
      snackbar.enqueueSnackbar(t('COMMON.TEXT_COPIED'), {
        variant: 'default',
        autoHideDuration: 2000,
      });
    } catch (err) {
      console.error('Clipboard copy failed:', err);
    }
  };

  return (
    <div key={key} className={clsx(styles.messageWrap, styles[item.type])}>
      <div className={styles.messageText}>
        {item.outgoing?.question && (
          <ReactMarkdown>{item.outgoing?.question}</ReactMarkdown>
        )}
        {item.incoming?.assembled_result?.response && (
          <div className={styles.textBlock}>
            <Stack direction="row">
              <Box flex={1}>
                <Divider title={t('MASK.MESSAGE')} />
              </Box>
              <IconButton
                onClick={() =>
                  copyMarkdown(item.incoming?.assembled_result?.response)
                }
              >
                <ContentCopy />
              </IconButton>
            </Stack>

            <ReactMarkdown>
              {item.incoming?.assembled_result?.response}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};
